import { Loader2 } from "lucide-react"

import { StepHeader, WizardLayout } from "@/components/agents/setup/shell"
import { YesNoCards } from "@/components/agents/setup/yes-no-cards"
import { Button } from "@/components/ui/button"

// IMP-461: the first decision — should the bot take messages so the
// business can follow up? The page derives conversion_goal/captures from this
// plus the booking decision.
export function CollectStep({
  stepNumber,
  totalSteps,
  value,
  onChange,
  onNext,
  processing,
}: {
  stepNumber: number
  totalSteps: number
  value: boolean
  onChange: (v: boolean) => void
  onNext: () => void
  processing: boolean
}) {
  return (
    <WizardLayout
      footer={
        <Button onClick={onNext} disabled={processing}>
          {processing && <Loader2 className="size-4 animate-spin" />}
          Continue
        </Button>
      }
    >
      <StepHeader
        eyebrow={`Step ${stepNumber} of ${totalSteps}`}
        title="Should I take messages?"
        description="When a visitor needs more than I can do in chat, I can take a message."
      />
      <YesNoCards
        yesLabel="Yes, take messages"
        yesSub="I'll take a message and send it to you."
        noLabel="No, don't take messages"
        noSub="I'll answer questions, but won't take messages."
        value={value}
        onChange={onChange}
      />
    </WizardLayout>
  )
}
